<script>
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { useExamFetchStore } from "@/stores/exam/exam-fetch-store";
import { useAuthStore } from "@/stores/auth-store";
import { useExamDataStore } from "@/stores/exam/exam-data-store";
import VideoPlayer from "@/components/CustomComponent/shared/VidioPlayer.vue";
import { Modal } from "bootstrap";

export default {
  props: ["examID"],
  components: {
    BaseLoading,
    VideoPlayer,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 5,
      searchQuery: "",
      currentVideoUrl: null, // untuk video modal
      videoModal: null, // instance bootstrap modal
      gradingScore: 0,
      selectedSubmissionID: null,
    };
  },
  computed: {
    sharedStore() {
      return useSharedStore();
    },
    ExamFetchStore() {
      return useExamFetchStore();
    },
    examDataStore() {
      return useExamDataStore();
    },
    AuthStore() {
      return useAuthStore();
    },
    needGradedCount() {
      // Status "Pending" artinya perlu di-grade
      return (
        this.ExamFetchStore.submissionByExamList?.filter(
          (s) => s.status === "Pending"
        ).length || 0
      );
    },
    passedCount() {
      return (
        this.ExamFetchStore.submissionByExamList?.filter(
          (s) => s.status === "Passed"
        ).length || 0
      );
    },
    failedCount() {
      return (
        this.ExamFetchStore.submissionByExamList?.filter(
          (s) => s.status === "Failed"
        ).length || 0
      );
    },
    submissionList() {
      return this.ExamFetchStore.submissionByExamList || [];
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.submissionList.length / this.perPage));
    },
    paginatedItem() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.submissionList.slice(start, end);
    },
  },
  watch: {
    submissionList() {
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
      }
    },
  },
  methods: {
    editCourse(examID) {
      this.$router.push({ name: "CourseExam", params: { examID } });
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    openVideoModal(videoPath, submissionID) {
      this.selectedSubmissionID = submissionID;
      this.currentVideoUrl = `${this.AuthStore.Url}/${videoPath}`;
      if (!this.videoModal) {
        const modalEl = document.getElementById("videoModal");
        this.videoModal = new Modal(modalEl);
      }
      this.videoModal.show();
    },
    async submitGrading() {
      try {
        await this.examDataStore.gradePractical(this.selectedSubmissionID);

        this.videoModal.hide();
        await this.ExamFetchStore.fetchExamSubmissionsList(this.examID);
        this.sharedStore.showSuccess("Nilai berhasil disimpan!");
      } catch (error) {
        console.error("Gagal menyimpan nilai:", error);
        const detail =
          error?.response?.data?.error ||
          error?.response?.data?.detail ||
          "Gagal menyimpan nilai";
        this.sharedStore.showError(detail);
      }
    },
  },
  mounted() {
    this.ExamFetchStore.fetchExamSubmissionsByExam(this.examID);
    this.ExamFetchStore.fetchExamSubmissionsList(this.examID);
  },
};
</script>
<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2"><!-- Quiz -->Exam Results</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                <!-- Quiz -->Exam Results
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <instructor-header></instructor-header>
      <div class="row">
        <!-- Sidebar -->
        <instructor-sidebar></instructor-sidebar>
        <!-- /Sidebar -->
        <div class="col-lg-9">
          <h5 class="page-title"><!-- Quiz -->Exam Results</h5>
          <div class="card">
            <div class="card-body">
              <div class="d-sm-flex align-items-center">
                <div class="quiz-img me-3 mb-2 mb-sm-0">
                  <img
                    :src="`${AuthStore.Url}/media/${ExamFetchStore.examDetail?.course_thumbnail}`"
                    alt=""
                  />
                </div>
                <div>
                  <h5 class="mb-2">
                    {{ ExamFetchStore.examDetail?.course_name }}
                  </h5>
                  <div class="question-info d-flex align-items-center">
                    <p
                      class="d-flex align-items-center fs-14 me-2 pe-2 border-end mb-0"
                    >
                      <i
                        class="isax isax-message-question5 text-primary-soft me-2"
                      ></i
                      >{{ ExamFetchStore.submissionByExamList?.length }}
                      Submission
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="card bg-info-transparent border-0">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <h6 class="mb-1 fw-normal text-gray-5">Need Graded</h6>
                      <span class="fs-20 fw-bold mb-1 d-block text-gray-9">{{
                        needGradedCount
                      }}</span>
                    </div>
                    <div class="icon-box bg-soft-info">
                      <img src="@/assets/img/icon/document.svg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="card bg-secondary-transparent border-0">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <h6 class="mb-1 fw-normal text-gray-5">Passed</h6>
                      <span class="fs-20 fw-bold mb-1 d-block text-gray-9">{{
                        passedCount
                      }}</span>
                    </div>
                    <div class="icon-box bg-soft-secondary">
                      <img src="@/assets/img/icon/user-tick.svg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="card bg-purple-transparent border-0">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <h6 class="mb-1 fw-normal text-gray-5">Failed</h6>
                      <span class="fs-20 fw-bold mb-1 d-block text-gray-9">{{
                        failedCount
                      }}</span>
                    </div>
                    <div class="icon-box bg-soft-purple">
                      <img src="@/assets/img/icon/users.svg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive custom-table">
            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th>Student Name</th>
                  <th>Score</th>
                  <th>Attempts</th>
                  <th>Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="paginatedItem.length === 0">
                  <td colspan="5" class="text-center">No data</td>
                </tr>
                <tr
                  v-for="(item, index) in paginatedItem"
                  :key="item.submissionID || index"
                >
                  <td>
                    <div class="d-flex align-items-center">
                      <img
                        :src="`${
                          AuthStore.authUrl
                        }/storage/photo/${AuthStore.userPhoto(item.studentID)}`"
                        alt=""
                        class="avatar avatar-md avatar-rounded flex-shrink-0 me-2"
                      />
                      {{ AuthStore.userName(item.studentID) }}
                    </div>
                  </td>
                  <td>{{ item.totalScore || "0.00" }}</td>
                  <td>{{ item.attempt }}</td>
                  <td>
                    <span
                      v-if="item.status?.toLowerCase() === 'pending'"
                      class="badge badge-sm bg-warning"
                    >
                      {{ item.status }}
                    </span>
                    <span
                      v-else-if="item.status?.toLowerCase() === 'passed'"
                      class="badge badge-sm bg-success"
                    >
                      {{ item.status }}
                    </span>
                    <span
                      v-else-if="item.status?.toLowerCase() === 'failed'"
                      class="badge badge-sm bg-danger"
                    >
                      {{ item.status }}
                    </span>
                    <span v-else class="badge badge-sm bg-secondary">
                      {{ item.status }}
                    </span>
                  </td>
                  <td class="text-center">
                    <router-link
                      v-if="item.status?.toLowerCase() === 'pending' && (item.exam.examType === 'Written' || item.exam.examType === 'Both')"
                      :to="`/instructor/instructor-exam-grading/${item.submissionID}`"
                      title="Grade Exam"
                    >
                      <i class="isax isax-edit-2"></i>
                    </router-link>
                    <i
                      v-if="
                        item.status?.toLowerCase() === 'pending' &&
                        (item.exam.examType === 'Practical' ||
                          item.exam.examType === 'Both') &&
                        item.examVideoPath
                      "
                      class="isax isax-video-play mx-2"
                      title="Grade Practical Video"
                      @click="
                        openVideoModal(item.examVideoPath, item.submissionID)
                      "
                      style="cursor: pointer"
                    ></i>

                    <i
                      v-else-if="
                        item.status?.toLowerCase() === 'pending' && (
                        item.exam.examType === 'Practical' ||
                        item.exam.examType === 'Both'
                      )"
                      class="isax isax-info-circle ms-1"
                      data-bs-toggle="tooltip"
                      data-bs-placement="right"
                      title="User Belum Upload Video Exam."
                    ></i>
                    <span
                      v-if="item.status?.toLowerCase() !== 'pending'"
                      class="text-muted fs-13"
                    >-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- /pagination -->
          <div class="row align-items-center mt-4">
            <div class="col-md-2">
              <p class="fs-14 fw-500 text-center text-md-start">
                Page {{ currentPage }} of {{ totalPages }}
              </p>
            </div>
            <div class="col-md-10">
              <ul
                class="pagination lms-page justify-content-center justify-content-md-end mt-2 mt-md-0"
              >
                <li
                  class="page-item prev"
                  :class="{ disabled: currentPage === 1 }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    tabindex="-1"
                    @click="goToPage(currentPage - 1)"
                    ><i class="fas fa-angle-left"></i
                  ></a>
                </li>
                <li
                  class="page-item"
                  v-for="page in totalPages"
                  :key="page"
                  :class="{ active: currentPage === page }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    @click="goToPage(page)"
                  >
                    {{ page }}</a
                  >
                </li>
                <li
                  class="page-item next"
                  :class="{
                    disabled:
                      currentPage === totalPages || submissionList.length === 0,
                  }"
                >
                  <a
                    class="page-link"
                    href="javascript:void(0)"
                    @click="goToPage(currentPage + 1)"
                    ><i class="fas fa-angle-right"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <!-- /pagination -->
        </div>
      </div>
    </div>
  </div>
  <!-- Footer -->
  <!-- <footer-two></footer-two> -->
  <!-- /Footer -->

  <!-- Video Dialog -->
  <div
    class="modal fade"
    id="videoModal"
    tabindex="-1"
    aria-labelledby="videoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="videoModalLabel">Exam Video</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <VideoPlayer :src="currentVideoUrl" :isTeacher="true" />
          <div class="grading-form">
            <div class="my-3">
              <label class="form-label">Nilai (0 - 100)</label>
              <input
                type="number"
                class="form-control"
                v-model.number="examDataStore.practicalScore"
                min="0"
                max="100"
                placeholder="Masukkan nilai"
              />
            </div>
            <div class="text-end">
              <button
                type="button"
                class="btn btn-success"
                :disabled="
                  examDataStore.practicalScore === '' ||
                  examDataStore.practicalScore < 0 ||
                  examDataStore.practicalScore > 100
                "
                @click="submitGrading"
              >
                Simpan Penilaian
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <BaseLoading v-show="sharedStore.loading"></BaseLoading>
</template>
